import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select, DatePicker } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';
import { FormSubtotal } from './subtotal';

const TermOfPayment = [
  { value: 15, label: '15 Hari' },
  { value: 30, label: '30 Hari' },
  { value: 45, label: '45 Hari' },
];

const initialState = {
  customer: null,
  term_of_payment: null,
  schedule_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  due_at: null,
  billing_to: null,
  billing_address: null,
  is_term_of_payment: false,
  note: '',
  calculate: null,
};

export const FormGeneral = ({
  data,
  onChange,
  isLoading,
  orders
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      customer,
      term_of_payment,
      schedule_at,
      due_at,
      billing_to,
      billing_address,
      is_term_of_payment,
      note,
      calculate
    },
    setState,
  ] = React.useState(initialState);

  const $handleCustomer = async (e) => {
    setState((prevState) => ({
      ...prevState,
      customer: e,
      billing_to: e?.finance_name || e?.pic_name,
      billing_address: e?.address,
    }));
  };

  const $handleSchedule = async (e) => {
    setState((prevState) => ({
      ...prevState,
      schedule_at: { default: e, formatted: formatDate(e, 'YYYY-MM-DD') },
      term_of_payment: null,
    }));
  };

  const $handleTermOfPayment = async (e) => {
    setState((prevState) => ({
      ...prevState,
      term_of_payment: e,
    }));

    if (e !== null) {
      const due = new Date(schedule_at?.formatted);
      due.setDate(due.getDate() + e?.value);
      setState((prevState) => ({
        ...prevState,
        due_at: { default: due, formatted: formatDate(due, 'YYYY-MM-DD') },
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        due_at: null,
      }));
    }
  };

  React.useEffect(() => {
    const state = {
      customer,
      term_of_payment,
      schedule_at,
      due_at,
      billing_to,
      billing_address,
      is_term_of_payment,
      note,
      calculate
    };

    onChange(state);
  }, [
    customer,
    term_of_payment,
    schedule_at,
    due_at,
    billing_to,
    billing_address,
    is_term_of_payment,
    note,
    calculate,
  ]);

  React.useEffect(() => {
    if (!data) return;

    const top =
      data?.term_of_payment === 15
        ? TermOfPayment[0]
        : data?.term_of_payment === 30
        ? TermOfPayment[1]
        : data?.term_of_payment === 45
        ? TermOfPayment[2]
        : null;
    setState((prevState) => ({
      ...prevState,
      customer: data?.customer,
      term_of_payment: data?.term_of_payment > 0 ? top : null,
      schedule_at: {
        default: new Date(data?.schedule_at),
        formatted: formatDate(data?.schedule_at, 'YYYY-MM-DD'),
      },
      due_at: {
        default: new Date(data?.due_at),
        formatted: formatDate(data?.due_at, 'YYYY-MM-DD'),
      },
      billing_to: data?.billing_to,
      billing_address: data?.billing_address,
      is_term_of_payment: data?.term_of_payment > 0 ? true : false,
      note: data?.note,
    }));
  }, [data]);

  return (
    <div className="sidebar h-100 ">
      <div
        className="form-group sidebar-body-create py-3 pe-0 pe-md-3"
        style={{ overflow: 'auto', maxHeight: 'calc(100vh - 20vh)' }}
      >
        {isLoading ? (
          <SkeletonsForm count={7} />
        ) : (
          <div>
            <div className="mb-3">
              <Select.Remote
                required
                label="Pilih Customer"
                placeholder=""
                url="/partner"
                params={{'type': 'customer', 'search': customer ? customer?.name: ''}}
                initialValue={customer?.id}
                keys={customer?.id}
                row={(d) => {
                  return { value: d.id, label: d.name };
                }}
                onSelected={(c) => {
                  $handleCustomer(c);
                }}
                errors={StateForm?.errors?.customer_id}
              />
            </div>

            <Form.Input
              label="Finance"
              required
              type="text"
              value={billing_to || ''}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  billing_to: e.target.value,
                }))
              }
              error={StateForm?.errors?.billing_to}
            />

            <Form.Textbox
              label="Alamat Penagihan"
              required
              type="text"
              value={billing_address || ' '}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  billing_address: e.target.value,
                }))
              }
              error={StateForm?.errors?.billing_address}
            />

            <div className="mb-3">
              <label className="form-label required">Tanggal Penagihan</label>
              <div
                className={
                  StateForm?.errors?.schedule_at
                    ? 'border border-danger rounded'
                    : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={schedule_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    $handleSchedule(date);
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.schedule_at}
                />
              </div>

              {StateForm?.errors?.schedule_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.schedule_at}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <Form.Checkbox
                disabled={!schedule_at?.default}
                onChange={() => {
                  if (!is_term_of_payment) {
                    setState((prevState) => ({
                      ...prevState,
                      is_term_of_payment: true,
                      term_of_payment: null,
                    }));
                  } else {
                    setState((prevState) => ({
                      ...prevState,
                      is_term_of_payment: false,
                      term_of_payment: null,
                    }));
                  }
                }}
                iconSize={18}
                value={is_term_of_payment}
                label="Pilih Ketentuan Pembayaran"
                required={is_term_of_payment}
              />
              {is_term_of_payment && (
                <div className="mt-2">
                  <Select
                    isClearable
                    classNamePrefix={
                      StateForm?.errors?.term_of_payment
                        ? 'is-invalid'
                        : 'select'
                    }
                    placeholder=""
                    value={term_of_payment}
                    options={TermOfPayment}
                    onChange={(e) => $handleTermOfPayment(e)}
                    error={StateForm?.errors?.term_of_payment}
                    isDisabled={!schedule_at?.default}
                  />

                  {StateForm?.errors?.term_of_payment ? (
                    <div
                      className="invalid-feedback"
                      style={{ display: 'block' }}
                    >
                      {StateForm?.errors?.term_of_payment}
                    </div>
                  ) : null}
                </div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label required">Jatuh Tempo</label>
              <div
                className={
                  StateForm?.errors?.due_at
                    ? 'border border-danger rounded'
                    : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={due_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      due_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.due_at}
                  isDisabled={is_term_of_payment}
                />
              </div>

              {StateForm?.errors?.due_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.due_at}
                </div>
              ) : null}
            </div>

            <Form.Textbox
              label="Catatan"
              type="text"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </div>
        )}

        <FormSubtotal
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, calculate: e }))
          }
          isLoading={isLoading}
          data={data}
          orders={orders}
        />
      </div>
    </div>
  );
};
